<template>
  <div>
    <main>
      <!-- <section class="relative w-full h-full py-40 min-h-screen"> -->
      <!-- :style="`background-image: url('${login_bg}');`" -->
      <!-- <div class="absolute top-0 w-full h-full bg-gray-300"></div> -->
      <router-view />
      <!-- </section> -->
    </main>
  </div>
</template>
<script setup>
import { ref } from "vue";
import login_bg from "@/assets/img/login_bg.png";

// 배경 이미지 ref 선언 (단순 상수이므로 ref 없이도 가능)
const bgImage = login_bg;
</script>
